export default __webpack_public_path__ + "static/media/File No. 2.a7058b7d.pdf";